import { env } from '../../../../App/config/env';

export function getLogo() {
  return env.APP_ENV.logo;
}
